/**
 * Row order for the line items of one invoice.
 *
 * A discount reads where the money it takes off is, so a coupon applied to a property sits inside
 * that property's block, after the charges it reduces. Only an account-wide discount, which
 * belongs to no property, closes the table.
 */

/** A discount that reduces the whole invoice rather than one property's charges. */
export function isAccountDiscount(item) {
  var _item$propertyAddress;
  return !!(item !== null && item !== void 0 && item.isDiscount) && !((_item$propertyAddress = item === null || item === void 0 ? void 0 : item.propertyAddress) !== null && _item$propertyAddress !== void 0 ? _item$propertyAddress : '');
}
export function sortInvoiceItems(items) {
  return [...(items !== null && items !== void 0 ? items : [])].sort((a, b) => {
    var _a$propertyAddress, _b$propertyAddress;
    if (isAccountDiscount(a) !== isAccountDiscount(b)) return isAccountDiscount(a) ? 1 : -1;
    const byAddress = String((_a$propertyAddress = a.propertyAddress) !== null && _a$propertyAddress !== void 0 ? _a$propertyAddress : '').localeCompare(String((_b$propertyAddress = b.propertyAddress) !== null && _b$propertyAddress !== void 0 ? _b$propertyAddress : ''), undefined, {
      numeric: true,
      sensitivity: 'base'
    });
    if (byAddress !== 0) return byAddress;

    // Within one property, its discount follows the charges.
    if (!!a.isDiscount !== !!b.isDiscount) return a.isDiscount ? 1 : -1;
    return 0;
  });
}